import apiClient from '../../../shared/services/apiClient';
import { unwrapEnvelopeData } from '../../../shared/services/apiHelpers';

const unwrapArray = (val) => {
  if (val == null) return [];
  if (Array.isArray(val)) return val;
  if (Array.isArray(val.$values)) return val.$values;
  return [];
};

const normalizeNotification = (row) => {
  if (!row || typeof row !== 'object') return row;
  const ids = unwrapArray(row.ids ?? row.Ids);
  const count = row.count ?? row.Count ?? 1;
  const leadDisplayName =
    row.leadDisplayName ?? row.LeadDisplayName ?? '';
  const leadAssignedId = row.leadAssignedId ?? row.LeadAssignedId ?? '';
  const notificationId =
    row.notificationId ?? row.NotificationId ?? ids[0] ?? '';
  return {
    ids,
    notificationId,
    leadAssignedId,
    leadDisplayName,
    date: row.date ?? row.Date,
    count,
    message:
      row.message ??
      row.Message ??
      (leadDisplayName
        ? `${leadDisplayName} assigned to you`
        : count === 1
          ? '1 new lead assigned to you'
          : `${count} new leads assigned to you`),
  };
};

const normalizeNotificationResponse = (raw) => {
  const envelope = raw?.value ?? raw;
  const payload =
    envelope?.leadAssignedNotifications || envelope?.LeadAssignedNotifications
      ? envelope
      : envelope?.data ?? envelope?.Data ?? envelope;
  const notifications = unwrapArray(
    payload?.leadAssignedNotifications ?? payload?.LeadAssignedNotifications
  ).map(normalizeNotification);

  const totalFromApi =
    payload?.totalCount ?? payload?.TotalCount ?? null;
  const totalCount =
    totalFromApi != null
      ? totalFromApi
      : notifications.reduce((sum, n) => sum + (n.count || 0), 0);

  return { totalCount, leadAssignedNotifications: notifications };
};

const NotificationService = {
  getnotifications: async (userId) => {
    try {
      const response = await apiClient.get(
        `/LeadAssignedNotification/GetLeadAssignedNotificationsByUserId/${userId}`
      );
      const data = unwrapEnvelopeData(response);
      return unwrapArray(data?.$values ?? data).map(normalizeNotification);
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  getNotificationsByDateAsync: async (userId) => {
    try {
      const response = await apiClient.get(
        `/LeadAssignedNotification/GetNotificationsByDate/${userId}`
      );
      const data = unwrapEnvelopeData(response);
      return unwrapArray(data?.$values ?? data).map(normalizeNotification);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  clearLeadAssignedNotificationById: async (id) => {
    try {
      const response = await apiClient.put(
        `/LeadAssignedNotification/ClearLeadAssignedNotificationById/${id}`
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        const err = new Error(
          typeof error.response.data === 'string'
            ? error.response.data
            : 'This lead is no longer available.'
        );
        err.status = 404;
        err.response = error.response;
        throw err;
      }
      throw error;
    }
  },

  getAppNotifications: async (userId) => {
    try {
      const response = await apiClient.get(
        `/LeadAssignedNotification/AppNotifications/${userId}`
      );
      return normalizeNotificationResponse(unwrapEnvelopeData(response));
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default NotificationService;
